export enum UserType {
  CREATOR = 'creator',
  BUYER = 'buyer',
}
export interface UserLoginPreferencesInput {
  navigationTarget: UserType
}
